<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center ht-70">
        <i class="icon ion-stats-bars"></i>
        <div class="mg-l-20">
          <h4>{{ $t("router.KPI报表管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <a
          class="btn"
          :class="checkArr.length > 0 ? 'btn-primary' : 'btn-outline-secondary'"
          href="javascript:;"
          @click="exportReport"
        >
          {{ $t("financial.导出KPI数据") }}
        </a>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="kDateCodeGeq || kDateCodeLeq"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('date')"
        >
          {{ $t("financial.同步日期") }}：
          <span class="mg-r-10"
            >{{ kDateCodeGeq }} {{ $t("financial.至") }}
            {{ kDateCodeLeq }}</span
          >
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["kDateCodeGeq", "kDateCodeLeq", "checkArr",'kpiStatus'],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    exportReport() {
      this.$emit("exportReport");
    },
  },
};
</script>